/*
  Display List of notifications in dashboard/account pages.
 */
import { uniqBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import notificationItemDashboard from '@/components/notification-items/notifcation-item-dashboard/notification-item-dashboard.vue';
import unreadNotificationMixin from '@/mixins/unreadNotification';
import contentLoaderMixin from '@/mixins/contentLoader';

const NOTIFICATION_COUNT_LIMIT = 99;
const NO_ITEMS_MESSAGE = 'There are no notifications';
const NO_MORE_ITEMS_MESSAGE = 'No more notifications to display';

export default {
  mixins: [
    contentLoaderMixin,
    unreadNotificationMixin,
  ],
  props: {
    limit: {
      type: Number,
      default: null,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  components: {
    notificationItemDashboard,
    infiniteLoading,
  },
  data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('dashboard', ['notifications', 'notificationsToggle']),
    ...mapState('user', ['userData']),
    items() {
      let data = this.notifications.data;

      if (this.limit) {
        data = this.notifications.data.slice(0, this.limit);
      }
      return uniqBy(data, el => el.notificationId);
    },
    moreNotificationsModifiers() {
      return {
        'notifications-list__footer-button': true,
        'notifications-list__footer-button--expanded': true,
      };
    },
    notificationsCount() {
      const total = this.notifications.totalCount;
      return (total > NOTIFICATION_COUNT_LIMIT) ? NOTIFICATION_COUNT_LIMIT : total;
    },
    showInfiniteLoading() {
      return this.notifications.canLoadMore && !this.limit;
    },
    isScrollMore() {
      return this.infiniteLoader && this.notifications.canLoadMore && this.items.length > 0;
    },
  },
  watch: {
    notificationsToggle() {
      this.infiniteLoader = null;
      this.resetNotifications();
      this.loadNotifications();
    },
    items() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.notifications.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
      this.loadedInfo = (this.items.length > 0) ? NO_MORE_ITEMS_MESSAGE :
        NO_ITEMS_MESSAGE;
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'resetNotifications', 'getNotifications',
    ]),
    ...mapActions('notifications', ['toggleNotificationsWidget']),
    onSeeAllClick() {
      this.toggleNotificationsWidget();
      this.$router.push({ name: 'notifications' });
    },
    goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.notifications.canLoadMore) {
        this.loadNotifications();
      }
    },
    loadNotifications() {
      if (this.loading) return;

      this.loading = true;
      this.getNotifications().then(() => {
        this.loading = false;
        this.isComponentReady = true;
      });
    },
  },
  created() {
    this.resetNotifications();
    this.loadNotifications();
  },
};



// WEBPACK FOOTER //
// ./src/components/notifications-list/notifications-list.js